import api, { createApiWithNewBasePath } from "@api";
import { IServiceRequest } from "../types";

export interface IServiceRequestCategory {
  categoryId: number;
}

export const getServiceRequestCategory = async (
  serviceRequestId: number
): Promise<IServiceRequestCategory> => {
  const { data } = await api.get<unknown, IServiceRequestCategory>(
    `service_requests/${serviceRequestId}`
  );
  return data;
};

export const getServiceRequest = async (
  serviceRequestId: string
): Promise<IServiceRequest> => {
  const { data } = await createApiWithNewBasePath.get<
    unknown,
    IServiceRequest
  >(`service_requests/${serviceRequestId}?show_target=new_task_show`);
  return data;
};

export interface IUpdateServiceRequestPayload {
  /** The whole set: an id left out is destroyed, a new unattached one is
   * linked to the task (`ServiceRequestCreation::UpdateDraft`). */
  photo_attachments?: number[];
}

/** The client edit endpoint (RT-4394) — no AI, moderation or notification. */
export const updateServiceRequest = (
  serviceRequestId: number,
  payload: IUpdateServiceRequestPayload
) =>
  createApiWithNewBasePath.patch<
    { service_request: IUpdateServiceRequestPayload },
    unknown
  >(`service_requests/${serviceRequestId}`, { service_request: payload });
